import { render, staticRenderFns } from "./CustomBreadcrumb.vue?vue&type=template&id=5b0f850b&scoped=true&"
import script from "./CustomBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./CustomBreadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./CustomBreadcrumb.vue?vue&type=style&index=0&id=5b0f850b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0f850b",
  null
  
)

export default component.exports